import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import clsx from 'clsx';
export function Section({ children, label, index }) {
    const id = useId();
    return (_jsxs("div", { role: "group", className: clsx(index !== 0 && 'border-t my-4'), "aria-labelledby": label ? `be-select-${id}` : undefined, children: [label && (_jsx("div", { className: "block uppercase text-muted text-xs px-16 py-10", role: "presentation", id: `be-select-${id}`, "aria-hidden": "true", children: label })), children] }));
}
